import script from "./BlogPost.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPost.vue?vue&type=script&setup=true&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=2ec1f4d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec1f4d1"]])

export default __exports__